var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "goods_shipped" }, [_vm._v("本单发货货品：")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "content" },
      _vm._l(_vm.modelList, function(item, index) {
        return _c("div", { key: index, staticClass: "good-item" }, [
          _c(
            "div",
            { staticClass: "good-content" },
            [
              _c("viewer", [
                _c("img", {
                  staticClass: "good-img wc-preview-img",
                  attrs: { src: item.img, alt: "" }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "good-info" }, [
                _c("div", { staticClass: "good-text" }, [
                  _vm._v("型号全称：" + _vm._s(item.modelName))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "good-text" }, [
                  _vm._v("型号规格：" + _vm._s(item.modelNeedSendType))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "good-text" }, [
                  _vm._v("数量：" + _vm._s(item.allCount))
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "btn-box" },
            [
              _c(
                "el-button",
                {
                  staticClass: "small-btn",
                  attrs: { type: "danger", plain: "" }
                },
                [_vm._v("数量有误")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "small-btn",
                  attrs: { type: "success", plain: "" }
                },
                [_vm._v("核对正确")]
              )
            ],
            1
          )
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "order-detail" }, [
      _c("div", { staticClass: "img_box" }, [
        _c("img", {
          staticClass: "bhw_logo",
          attrs: { src: require("../../assets/check_logo.png"), alt: "" }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "title" }, [_vm._v("货物明细页-按发货单查看")]),
      _vm._v(" "),
      _c("div", { staticClass: "search_product_info" }),
      _vm._v(" "),
      _c("div", { staticClass: "d-line" }, [
        _c("div", { staticClass: "d-label" }, [_vm._v("收货人")]),
        _vm._v(" "),
        _c("div", { staticClass: "d-info" }, [_vm._v("sssfsdf")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-line" }, [
        _c("div", { staticClass: "d-label" }, [_vm._v("物流")]),
        _vm._v(" "),
        _c("div", { staticClass: "d-info" }, [_vm._v("德邦乌璐")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-line" }, [
        _c("div", { staticClass: "d-label" }, [_vm._v("发货仓库")]),
        _vm._v(" "),
        _c("div", { staticClass: "d-info" }, [_vm._v("济南云仓")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-line" }, [
        _c("div", { staticClass: "d-label" }, [_vm._v("订单数量")]),
        _vm._v(" "),
        _c("div", { staticClass: "d-info" }, [_vm._v("123")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-896b9bb8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-896b9bb8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/checkProduct/index.vue
// module id = null
// module chunks = 